<template>
  <div class="view-sale-bar-chart">
    <div class="row align-items-center mb-5">
      <div class="col-lg-4">
        <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
          <form-group
            v-model="filters.product_id"
            id="product-select"
            placeholder="Selecione..."
            select
            slim
            :options="[
              { id: 'all', name: 'Todos os produtos' },
              ...products.map(({ id, name }) => ({ id, name }))
            ]"
          />
        </action-dispatcher>
      </div>
      <div class="col-lg-3 mb-3 mb-lg-0">
        <action-dispatcher action="product/getCurrency">
          <form-group
            v-model="filters.currencyType"
            id="currency-select"
            placeholder="Selecione..."
            select
            slim
            :options="currencies"
          />
        </action-dispatcher>
      </div>
      <div class="col-lg-5">
        <switch-date-picker
          radius
          slim
          v-model="filters.dates"
          :options="[
            { title: 'Semana', rangeLength: 7 },
            { title: 'Mês', rangeLength: 30 },
            { title: 'Ano', rangeLength: 365 },
            { title: 'Período', rangeLength: null } //custom range
          ]"
        />
      </div>
    </div>
    <div class="chart-card overview-card">
      <action-dispatcher action="sale/get" :parameters="{}">
        <div v-if="loading" class="text-center">
          <b-spinner variant="primary" />
        </div>
        <bar-chart v-else :data="revenuesByProduct" />
      </action-dispatcher>
    </div>
  </div>
</template>
<script>
import SwitchDatePicker from "@/components/SwitchDatePicker.vue";
import ChartsMixin from "@/mixins/charts.js";
import BarChart from "./baseChart/Bar.js";

export default {
  mixins: [ChartsMixin],
  components: {
    BarChart,
    SwitchDatePicker
  },
  props: {
    externalLoading: {
      type: Boolean,
      default: false
    },
    chartColor: {
      type: String,
      default: "#9155EC"
    }
  },
  data() {
    return {
      loading: false,
      test: "",
      filters: {
        currencyType: "",
        product_id: "all",
        dates: []
      }
    };
  },
  mounted() {
    this.gradientColor = this.chartColor;
  },
  watch: {
    chartColor(val) {
      this.gradientColor = val; //mixin variable
    },
    externalLoading(val) {
      this.loading = val;
    },
    "filters.product_id"(product_id) {
      this.$emit("change-product", product_id);
    },
    "filters.currencyType"(currency_id) {
      this.$emit("change-currency", currency_id);
    },
    "filter.dates"(val) {
      if (val && val.length === 2) {
        this.$emit("change-date", val);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.view-sale-bar-chart {
  .chart-card {
    width: 100%;
    flex-grow: 1;
    padding: 20px;

    ::v-deepcanvas {
      max-height: 230px;
    }
  }
}
</style>
